module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNSAyNSIgZGF0YS1pY29uLW5hbWU9ImZhY2Vib29rLWNpcmNsZSI+CiAgICA8cGF0aCBkPSJNMTUuMjQ2IDguNDc4aC0xLjM1MWMtLjQ3NCAwLS41NzQuMTk1LS41NzQuNjg4djEuMTkxaDEuOTI1bC0uMTg3IDIuMDg5aC0xLjc0MXY2LjI0OGgtMi40OTV2LTYuMjIxSDkuNTI3di0yLjExNmgxLjI5NmwuMDAzLTEuNjY5YzAtMS41NjQuODM5LTIuMzgxIDIuNjk0LTIuMzgxaDEuNzI2djIuMTcxek0xMi41IDBDNS41OTcgMCAwIDUuNTk2IDAgMTIuNVM1LjU5NyAyNSAxMi41IDI1IDI1IDE5LjQwNCAyNSAxMi41IDE5LjQwMyAwIDEyLjUgMHoiIGZpbGw9IiNmZmZmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook-circle.svg
// module id = 621
// module chunks = 114276838955818